<template>
  <vx-card title="Контакты управляющей компании" class="text-lg mt-4">
    <div slot="actions">
      <vs-button
        v-if="$can('rp.main', 'write')"
        type="border"
        size="medium"
        @click="onAddGroup"
        class="vs-button_square"
      >
        Добавить группу
      </vs-button>
    </div>
    <div v-if="groups && !groups.length">
      -
    </div>
    <div v-else>
      <div :class="$style.head">
        <div :class="$style.name">Группа</div>
        <div :class="$style.phone">Телефоны</div>
        <div :class="$style.info">Доп. инфо</div>
        <div :class="$style.allowCall">Кнопка «Позвонить»</div>
        <div :class="$style.actions">Действия</div>
      </div>
      <div :key="group.id" v-for="group in groups" :class="$style.group">
        <div :class="$style.name">
          <div :class="$style.title">{{ group.name }}</div>
          <div :class="$style.footer">
            Действия с группой:
            <vs-button
              v-if="$can('rp.main', 'write')"
              class="ml-2"
              @click="onEditGroup(group)"
              iconPack="feather"
              icon="icon-edit"
              type="border"
              size="small"
              title="Редактировать"
            />
            <vs-button
              v-if="$can('rp.main', 'write')"
              class="ml-2"
              @click="onRemoveGroup(group)"
              iconPack="feather"
              icon="icon-trash"
              type="border"
              size="small"
              title="Удалить"
            />
          </div>
        </div>
        <div :class="$style.items">
          <div :key="phone.id" v-for="phone in group.contacts" :class="$style.item">
            <div :class="$style.phone">{{ phone.contact }}</div>
            <div :class="$style.info">{{ phone.description }}</div>
            <div :class="$style.allowCall">
              <feather-icon v-if="phone.is_callable" icon="CheckIcon" class="" />
            </div>
            <div :class="$style.actions">
              <vs-button
                v-if="$can('rp.main', 'write')"
                @click="onEditPhone(group, phone)"
                iconPack="feather"
                icon="icon-edit"
                type="border"
                size="small"
                title="Редактировать"
              />
              <vs-button
                v-if="$can('rp.main', 'write')"
                class="ml-2"
                @click="onRemovePhone(group, phone)"
                iconPack="feather"
                icon="icon-trash"
                type="border"
                size="small"
                title="Удалить"
              />
            </div>
          </div>

          <div :class="$style.item">
            <button v-if="$can('rp.main', 'write')" :class="$style.link" @click="onAddPhone(group)">
              + Добавить номер
            </button>
          </div>

        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:   "UCContacts",
  props:  ['buildingId'],
  mixins: [notifyHttpError],
  data() {
    return {
      groups:  null,
      loading: false,
    };
  },
  methods: {
    loadGroups() {
      this.loading = true;
      this.$http.get(`/building/${this.buildingId}/contact/group`, { params: { buildings_id: this.buildingId } }).then(
        ( { data } ) => this.groups = data,
        this.notifyHttpError,
      ).finally(() => this.loading = false);
    },

    onAddGroup() {
      this.$modal.open({
        size:           'md',
        title:          'Добавить группу',
        component:      () => import('@/components/main/UCContactsGroupFormModal'),
        componentProps: {
          onSave: ( { name } ) => {
            return this.$http.post(`/building/${this.buildingId}/contact/group`, {
              name,
              buildings_id: this.buildingId,
            }).then(this.loadGroups);
          },
        },
      });
    },

    onEditGroup( group ) {
      this.$modal.open({
        size:           'md',
        title:          'Редактировать группу',
        component:      () => import('@/components/main/UCContactsGroupFormModal'),
        componentProps: {
          group,
          onSave: ( { name } ) => {
            return this.$http.put(`/building/contact/group/${group.id}`, {
              name,
              buildings_id: this.buildingId,
            }).then(this.loadGroups);
          },
        },
      });
    },

    onRemoveGroup( group ) {
      this.$modal.openConfirm({
        message:    `Вы действительно хотите удалить группу "${group.name}"?`,
        buttonText: 'Удалить',
      }).result.then(() => {
        return this.$http.delete(`/building/contact/group/${group.id}`, { params: { buildings_id: this.buildingId } })
          .then(this.loadGroups);
      });
    },

    onAddPhone( group ) {
      this.$modal.open({
        size:           'md',
        title:          'Добавить номер',
        component:      () => import('@/components/main/UCContactsPhoneFormModal'),
        componentProps: {
          onSave: ( { contact, description, is_callable } ) => {
            return this.$http.post(`/building/contact/group/${group.id}/contact`, {
              contact,
              description,
              is_callable,
              buildings_id: this.buildingId,
            }).then(this.loadGroups);
          },
        },
      });
    },

    onEditPhone( group, phone ) {
      this.$modal.open({
        size:           'md',
        title:          'Редактировать номер',
        component:      () => import('@/components/main/UCContactsPhoneFormModal'),
        componentProps: {
          phone,
          onSave: ( { contact, description, is_callable } ) => {
            return this.$http.put(`/building/contact/${phone.id}`, {
              contact,
              description,
              is_callable,
              buildings_id: this.buildingId,
            }).then(this.loadGroups);
          },
        },
      });
    },

    onRemovePhone( group, phone ) {
      this.$modal.openConfirm({
        message:    `Вы уверены, что хотите удалить номер ${phone.contact}?`,
        buttonText: 'Удалить',
      }).result.then(() => {
        return this.$http.delete(`/building/contact/${phone.id}`, { params: { buildings_id: this.buildingId } })
          .then(this.loadGroups);
      });
    },
  },

  mounted() {
    this.loadGroups();
  },
  watch: {
    buildingId() {
      this.loadGroups();
    },
  },
};
</script>

<style lang="scss" module>
.head {
  display: flex;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 5px;

  > * {
    flex-shrink: 0;
  }
}

.group {
  display: flex;
  border: 1px solid #000;
  margin-top: -1px;

  > * {
    flex-shrink: 0;
  }

  .name {
    border-right: 1px solid #BFBFBF;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.items {
  flex: 1;
}

.item {
  display: flex;
  align-items: center;
  border-top: 1px solid #BFBFBF;
  height: 40px;

  &:first-child {
    border-top: 0;
  }

  > * {
    flex-shrink: 0;
  }
}

.name {
  width: 20%;
  min-width: 300px;
  flex-shrink: 0;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
}

.phone {
  width: 150px;
  padding: 0 5px;
}

.info {
  flex: 1;
  padding: 0 5px;
}

.allowCall {
  width: 150px;
  display: flex;
  align-items: center;
}

.actions {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 5px;
}

.title {
  font-size: 16px;
}

.footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
}

.link {
  border: 0;
  background-color: transparent;
  color: color(primary);
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  text-decoration: underline;
  cursor: pointer;
  margin: 0 5px;

  &:hover {
    text-decoration: none;
  }
}
</style>
